"use client";

import { AppProgressBar } from "next-nprogress-bar";
import { PropsWithChildren } from "react";

const TransitionProgressBar = ({ children }: PropsWithChildren) => {
  return (
    <>
      {children}
      <AppProgressBar height="2px" color="#2eba8b" options={{ showSpinner: false }} />
    </>
  );
};

export default TransitionProgressBar;
